import type { StreamCode } from "@/types/sync.types";
import { t } from "@lingui/core/macro";

export function getSyncWarningMessage(code: StreamCode): string {
  switch (code) {
    case "sync.warning.max_pages":
      return t`Reached the maximum number of pages. Some activities may be missing.`;

    case "sync.quota.reached":
      return t`Daily Strava API quota reached. Try again tomorrow.`;

    case "sync.lock.busy":
      return t`Another sync is already running. Please try again in a moment.`;

    case "sync.warning.missing_scope":
      return t`Strava permissions are missing. Please reconnect your Strava account and grant activity access to continue syncing.`;

    default:
      // Fallback: show code (useful for debugging even if untranslated)
      return code;
  }
}
